module.exports = __webpack_public_path__ + "img/En-T600.734c1293.gif";